var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 464,
    viewBox: "0 0 188 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188 .858a239.32 239.32 0 01-70.093 169.219 239.314 239.314 0 01-169.218 70.092V.858H188z",
    fill: "#F7F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188 223.862A239.311 239.311 0 01-51.311 463.173V223.862H188z",
    fill: "#F7F3FF"
  })));
}
export default SvgLeftIllustration;